import React from "react";
import { Helmet } from "react-helmet-async";
import Grid, { Actions, Columns } from "../../component/Grid";
import { useCrumbs } from "../../component/breadcrumbs";
import { useNavigate, useSearchParams } from "react-router-dom";
import useLocale from "../../util/i18n";
import { getSupplier, type Supplier } from "../../api/erp";
import { getConfig } from "../../api/core";

export default function Suppliers() {
    let { 0: editable, 1: setEditable } = React.useState(false);
    let { 0: query, 1: setQuery } = useSearchParams();
    let { 0: setCrumbs } = useCrumbs();
    let { 0: __ } = useLocale();
    let navigate = useNavigate();
    let columns = React.useMemo<Columns>(() => ({
        code: {
            label: 'ID',
            filterable: 'filter[code]'
        },
        name: {
            label: __('Name')
        },
        email: {
            label: __('Email')
        },
        currency: {
            label: __('Currency')
        },
        tax_rate: {
            label: __('Tax Rate')
        }
    }), [__]);
    let actions = React.useMemo<Actions>(() => editable ? [
        {
            label: __('Edit'),
            onClick: (item: Supplier) => {
                window.sessionStorage.setItem('Su-' + item.id, JSON.stringify(item));
                navigate('/supplier/' + (editable ? 'edit' : 'view') + '?id=' + item.id);
            }
        }
    ] : [], [__, editable]);
    const doLoad = React.useCallback((params: Record<string, any>) => {
        return getSupplier(params);
    }, []);
    React.useEffect(() => {
        setCrumbs(['Supplier']);
        if (window.sessionStorage.getItem('erp-editable')) {
            setEditable(window.sessionStorage.getItem('erp-editable') === '1');
        } else {
            getConfig('erp/service').then(response => {
                let result = !Boolean(response['erp/service']) ? '1' : '0';
                window.sessionStorage.setItem('erp-editable', result);
                setEditable(result === '1');
            });
        }
    }, [setEditable]);
    return (
        <>
            <Helmet>
                <title>{__('Supplier')}</title>
            </Helmet>
            <Grid newUrl={editable ? '/supplier/edit' : undefined} columns={columns} actions={actions} query={query} setQuery={setQuery} doLoad={doLoad} />
        </>
    );
}